<script setup lang="ts">
import router from "@/router/router";

const { errorMessage, title } = defineProps<{
	title: string;
	errorMessage: string;
}>();

const backToDataTable = () => {
	router.push({ name: "explorer.metricWrapper" });
};
</script>

<template>
	<div class="h-100">
		<div class="h-100 no-data-empty-state">
			<v-empty-state
				icon="fa: fa-duotone fa-cloud-binary"
				:text="errorMessage"
				:title="title"
			>
				<!--				action-text="Go back to data table"-->
				<!--				@click:action="backToDataTable"-->
			</v-empty-state>
		</div>
	</div>
</template>

<style scoped lang="scss"></style>
